export enum ULodPSDMitarbeiterTableEnum {
  personalNr = 'pnr_betriebliche#psd',
  email = 'email#psd',
  vorname = 'duevo_vorname#psd',
  nachname = 'duevo_familienname#psd',
  street = 'adresse_strassenname#psd',
  housenumber = 'adresse_strasse_nr#psd',
  zip = 'adresse_plz#psd',
  city = 'adresse_ort#psd',
  country = 'adresse_nation_kz#psd',
  staatsangehoerigkeit = 'staatsangehoerigkeit#psd',
  geburtsDatum = 'geburtsdatum_ttmmjj#psd',
  geburtsName = 'gebname#psd',
  geburtsOrt = 'gebort#psd',
  geburtsLand = 'geburtsland#psd',
  geschlecht = 'geschlecht#psd',
  familienstand = 'familienstand#psd',
  rentenVersicherungsNr = 'sozialversicherung_nr#psd',
  istVorhanden = 'schwerbeschaedigt#psd',
  lodasPersonalNr = 'pnr#psd',
  arbeitserlaubnis = 'arbeitserlaubnis#psd',
  namenszusatz = 'duevo_namenszusatz#psd',
  nazu_gebname = 'nazu_gebname#psd',
  auslandsPlz = 'adresse_plz_ausland#psd',
  telefonNr = 'telefon#psd',
  // verwErsteintrElenaBn = 'verw_ersteintr_elena_bn#psd',
  adresseAnschriftenzusatz = 'adresse_anschriftenzusatz#psd',
}

export enum ULodPsdMABankTableEnum {
  personalNr = 'pnr_betriebliche#psd',
  lodasPersonalNr = 'pnr#psd',
  iban = 'ma_iban#psd',
  kontoinhaber = 'ma_bank_kto_inhaber_abw#psd',
  zahlungsart = 'ma_bank_zahlungsart#psd',
}

export enum ULodPsdSteuerTableEnum {
  personalNr = 'pnr_betriebliche#psd',
  lodasPersonalNr = 'pnr#psd',
  steuerklasse = 'st_klasse#psd',
  steuerIdentNr = 'identifikationsnummer#psd',
  kinderFreibetrag = 'kfb_anzahl#psd',
  konfession = 'konf_an#psd',
  konfessionPartner = 'konf_ehe#psd',
  // factor = 'faktor#psd',
  verfuegbarkeit = 'els_2_haupt_ag_kz#psd',
  pauschalsteuer = 'pausch_einhtl_2#psd',
  pauschalsteuerANKZ = 'pausch_an_kz#psd',
}

export enum ULodPsdTaetigkeitTableEnum {
  personalNr = 'pnr_betriebliche#psd',
  lodasPersonalNr = 'pnr#psd',
  ausgTaetigkeit = 'ausg_taetigkeit#psd',
  schulabschluss = 'schulabschluss#psd',
  ausbildungsabschluss = ' ausbildungsabschluss#psd',
  arbeitnehmerueberlassung = 'arbeitnehmerueberlassung#psd',
  vertragsform = 'vertragsform#psd',
  rvBeitragsGruppe = 'rv_beitragsgruppe#psd',
  personenGruppe = 'persgrs#psd',
  beschaeft_nr = 'beschaeft_nr#psd',
}

export enum ULodPsdSozialversicherungTableEnum {
  personalNr = 'pnr_betriebliche#psd',
  lodasPersonalNr = 'pnr#psd',
  gesetzlichKrankenkasse = 'kk_nr#psd',
  freiwilligKrankenkasse = 'kk_nr_frw#psd',
  gvGfSchluessel = 'gv_gf_schluessel#psd',
  kzZuschlPvKinderlose = 'kz_zuschl_pv_kinderlose#psd',
  kvStatusKurzfr = 'kv_status_kurzfr#psd',
  arbeitslosenversicherungType = 'av_bgrs#psd',
  krankenversicherungType = 'kv_bgrs#psd',
  pflegeversicherungType = 'pv_bgrs#psd',
  rentenversicherungType = 'rv_bgrs#psd',
  applyMidijob = 'midijob_kz#psd',
  umlSchluessel = 'uml_schluessel#psd',
}

export enum ULodPsdPrivVersicherungTableEnum {
  personalNr = 'pnr_betriebliche#psd',
  lodasPersonalNr = 'pnr#psd',
  privatKrankenversichert = 'kv_priv_kz#psd',
  privatPflegeversichert = 'pv_priv_kz#psd',
  gesamtbeitragKv = 'gesamtbeitrag_kv#psd',
  gesamtbeitragPv = 'gesamtbeitrag_pv#psd',
  monatlBeitrantBasisKv = 'monatl_beitrant_basis_kv#psd',
}

export enum ULodPsdBeschaeftigungTableEnum {
  personalNr = 'pnr_betriebliche#psd',
  lodasPersonalNr = 'pnr#psd',
  eintrittdatum = 'eintrittdatum#psd',
  // datumUrsprBefr = 'datum_urspr_befr#psd', // geht kaputt, erstmal raus
}

export enum ULodPsdArbeitszeitRegelmTableEnum {
  personalNr = 'pnr_betriebliche#psd',
  lodasPersonalNr = 'pnr#psd',
  azWtlIndiv = 'az_wtl_indiv#psd',
  regelm_az_mo = 'regelm_az_mo#psd',
  regelm_az_di = 'regelm_az_di#psd',
  regelm_az_mi = 'regelm_az_mi#psd',
  regelm_az_do = 'regelm_az_do#psd',
  regelm_az_fr = 'regelm_az_fr#psd',
}

export enum ULodPsdFreibetragTableEnum {
  personalNr = 'pnr_betriebliche#psd',
  lodasPersonalNr = 'pnr#psd',
  jahresFreibetrag = 'freibetrag_jhrl#psd',
  monatsFreibetrag = 'freibetrag_mtl#psd',
  jahresHinzurechnungsbetrag = 'hinzu_jahresbetrag#psd',
  monatsHinzurechnungsbetrag = 'hinzu_monatsbetrag#psd',
}

export enum ULodPsdVermoegensbildungTableEnum {
  personalNr = 'pnr_betriebliche#psd',
  lodasPersonalNr = 'pnr#psd',
  vermoegensbildung = 'vwl_1_netto_abz_1#psd',
  vermoegensbildungArbeitgeberAnteil = 'vwl_ag_anteil_betrag_1#psd',
  lastschrifteinzug = 'lastschrift1_kz#psd',
  vwlIban = 'vwl_1_iban#psd',
  vertragsnummer = 'vwl_vertrag_nr_1#psd',
  vertragsart = 'vwl_1_vertragsart#psd',
  isAltersvermoegenswirksameLeistung = 'avwl1_kz#psd',
  vertragBegin = 'vwl_1_beginn_mmjj#psd',
  vertragEnd = 'vwl_1_ende_mmjj#psd',
  institut = 'vwl_institut_1#psd',
  vwlAgAnteil = 'vwl_ag_anteil_la_1#psd',
}

export enum ULodPsdOedTableEnum {
  personalNr = 'pnr_betriebliche#psd',
  lodasPersonalNr = 'pnr#psd',
  tarifgruppe = 'entgelt_grp1#psd',
  tarifgruppeZusatz = 'entgelt_grp2#psd',
  tarifstufe = 'stufe#psd',
  tarifstufeBeginn = 'stufe_gueltig_ab#psd',
}

export enum ULodMpdKrankenkasseTableEnum {
  kkNr = 'krankenkasse_nr#mpd',
  kkBetriebsnummer = 'kk_betr_nr',
  kkBezeichnung = 'krankenkasse_bezeichnung#mpd',
}

export enum ULodPsdBesonderheitenTableEnum {
  personalNr = 'pnr_betriebliche#psd',
  lodasPersonalNr = 'pnr#psd',
  entlohnungsform = 'entlohnungsform#psd',
}
